
import { supabase } from "../../integrations/supabase/client";

/**
 * Requests a password reset for a user
 */
export const requestPasswordReset = async (email: string) => {
  const { error } = await supabase.auth.resetPasswordForEmail(email, {
    redirectTo: `${window.location.origin}/update-password`,
  });
  
  if (error) throw error;
};

/**
 * Updates a user's password
 * @param password - The new password
 * @param sendConfirmationEmail - Whether to send a confirmation email
 */
export const updatePassword = async (password: string, sendConfirmationEmail: boolean = false) => {
  const { error } = await supabase.auth.updateUser({
    password,
  }, {
    emailRedirectTo: sendConfirmationEmail ? `${window.location.origin}/settings` : undefined
  });
  
  if (error) throw error;
};
